import { Flex, ModuleLayout, Spacing } from '@billy/design-system'
import React, { useCallback } from 'react'

import { useSkatConnection } from '@features/vatDeclarations/contexts/skatConnectionContext'
import { FoundSuggestionsBannerContent } from '@views/vatDeclarations/elements/VatSuggestions/elements/FoundSuggestionsBanner'
import { VatSuggestionsSource } from '@views/vatDeclarations/elements/VatSuggestions/enums/vatSuggestionsSource'

import { useOrganizationViewUrl } from '../../../../../../hooks/routing/useOrganizationViewUrl'
import { useVatDeclaration } from '../../../../context/vatDeclarationContext'
import { useVatDeclarationsRoutes } from '../../../../context/vatDeclarationsRouteContext'
import { useSubmitToSkatForm } from '../../../../hooks/useSubmitToSkatForm'
import { SkatBox } from '../../../SkatBox'
import { SkatModule } from '../../../SkatModule'
import { VatDeclarationsLoadingView } from '../../../VatDeclarationsLoadingView'
import { SubmitToSkatForm } from '../SubmitToSkatForm'
import { SubmitToSkatContextProvider } from '../SubmitToSkatForm/context/submitToSkatContext'
import { VatDeclarationReport } from '../VatDeclarationReport'
import { VatDeclarationSideActions } from '../VatDeclarationSideActions'
import { VatDeclarationStatusCard } from '../VatDeclarationStatusCard'
import * as Styled from './styles'

export const VatDeclarationViewDK = () => {
  const { isSkatConnected } = useSkatConnection()
  const { vatDeclaration, isLoading, id } = useVatDeclaration()
  const { isSubmissionFormOpen, setIsSubmissionFormOpen } = useSubmitToSkatForm()
  const vatDeclarationsRoutes = useVatDeclarationsRoutes()
  const { url: vatDeclarationsUrl } = useOrganizationViewUrl(vatDeclarationsRoutes.getMainRoute())

  const period = vatDeclaration?.periodText

  const handleShowIntegrationForm = useCallback(
    (isOpen: boolean) => {
      setIsSubmissionFormOpen(isOpen, id)
    },
    [id, setIsSubmissionFormOpen],
  )

  if (isLoading || !vatDeclaration) {
    return <VatDeclarationsLoadingView />
  }

  if (isSubmissionFormOpen) {
    return (
      <SubmitToSkatContextProvider isSubmissionFormOpen={isSubmissionFormOpen} declarationId={id}>
        <SubmitToSkatForm setIsSubmissionFormOpen={handleShowIntegrationForm} />
      </SubmitToSkatContextProvider>
    )
  }

  return (
    <SkatModule>
      <ModuleLayout
        backButtonTo={vatDeclarationsUrl}
        sideActions={
          <VatDeclarationSideActions
            onShowIntegrationForm={handleShowIntegrationForm}
            isSkatConnected={isSkatConnected}
          />
        }
        title={period}
        withBackButton
      >
        <FoundSuggestionsBannerContent source={VatSuggestionsSource.ReportPage} vatDeclarationId={id} />
        <Flex gap={Spacing.S32}>
          <VatDeclarationReport />
          <Styled.StatusCardWrapper>
            <VatDeclarationStatusCard />
            <SkatBox />
          </Styled.StatusCardWrapper>
        </Flex>
      </ModuleLayout>
    </SkatModule>
  )
}
